// For web component mode - routing disabled
// import { AppRoutingModule } from './app-routing.module';

// Code needed for serve or web components
import { APP_INITIALIZER, DoBootstrap, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { AppComponent } from './app.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { createCustomElement } from '@angular/elements';

import { catchError, Observable, of, tap, from, switchMap } from 'rxjs';

import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { PanelModule } from 'primeng/panel';
import { ToastModule } from 'primeng/toast';
import { MessageModule } from 'primeng/message';
import { CheckboxModule } from 'primeng/checkbox';
import { StepperModule } from 'primeng/stepper';
import { FileUploadModule } from 'primeng/fileupload';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { OrderListModule } from 'primeng/orderlist';
import { DividerModule } from 'primeng/divider';
import { FieldsetModule } from 'primeng/fieldset';
import { PanelMenuModule } from 'primeng/panelmenu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TabViewModule } from 'primeng/tabview';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { PasswordModule } from 'primeng/password';

import { MessageService } from 'primeng/api';

import { AppComponent } from './app.component';
import { MonthlyInvoiceListComponent } from './pages/monthly-invoice-list/monthly-invoice-list.component';
import { MonthlyInvoiceDetailsPageComponent } from './pages/invoice-details-page/monthly-invoice-details-page.component';
import { InvoiceLineItemsComponent } from './components/invoice-line-items/invoice-line-items.component';
import { InvoiceContactListComponent } from './components/invoice-contact-list/invoice-contact-list.component';
import { InvoiceListComponent } from './pages/invoice-list/invoice-list.component';
import { TenantListComponent } from "./pages/tenant-list/tenant-list.component";
import { ReportsComponent } from './pages/reports/reports.component';
import { TenantUpdatePageComponent } from "./pages/tenant-update/tenant-update-page.component";
import { SettingsComponent } from './pages/settings/settings.component';
import { LeaseListComponent } from './pages/lease-list/lease-list.component';
import { LeaseViewComponent } from './pages/lease-view/lease-view.component';
import { DEVJABComponent } from './dev-jab/dev-jab.component';
import { SUREPARKBillCouponsComponent } from './pages/sureparkbill-coupons/sureparkbill-coupons.component';
import { PerformaceMetricsComponent } from './pages/performace-metrics/performace-metrics.component';
import { SequenceManagementComponent } from './pages/sequence-management/sequence-management.component';
import { AccountsValidityUpdateComponent } from './pages/accounts-validity-update/accounts-validity-update.component';
import { TerminateContactsComponent } from './pages/terminate-contacts/terminate-contacts.component';
import { SureparkMergeComponent } from './pages/surepark-merge/surepark-merge.component';
import { DreReportComponent } from './pages/dre-report/dre-report.component';
import { ImportDailySummaryComponent } from './pages/import-daily-summary/import-daily-summary.component';
import { SUREPARKMemberIDsReportComponent } from './pages/surepark-member-ids-report/surepark-member-ids-report.component';
import { NavigationService } from './services/navigation/navigation.service';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ContactsListComponent } from './shared/components/contacts-list/contacts-list.component';
import { LocationSwitcherComponent } from './components/location-switcher/location-switcher.component';
import { LocationDisplayComponent } from './components/location-display/location-display.component';
import { TestLoginComponent } from './pages/test-login/test-login.component';
import { TestLogoutComponent } from './pages/test-logout/test-logout.component';

import { AuthService, CookieData } from './services/auth/auth.service';
import { TrpcService } from './services/trpc/trpc.service';
import { DailySummaryConfigurationComponent } from './pages/daily-summary-configuration/daily-summary-configuration.component';
import { CashierImportSheetSummaryComponent } from './components/cashier-import-sheet-summary/cashier-import-sheet-summary.component';
import { WpsImportSheetSummaryComponent } from './components/wps-import-sheet-summary/wps-import-sheet-summary.component';
import { SysparkImportSheetSummaryComponent } from './components/syspark-import-sheet-summary/syspark-import-sheet-summary.component';
import { MonthlyBillingSummaryWidgetComponent } from './components/monthly-billing-summary-widget/monthly-billing-summary-widget.component';
import { ApiInterceptor } from './interceptor/api.interceptor';
import { UpdateRateComponent } from './pages/update-rate/update-rate.component';
import { LotSettingsComponent } from './pages/lot-settings/lot-settings.component';
import { VersionComponent } from './pages/version/version.component';
import { DevInvoiceGenerationComponent } from './pages/dev-invoice-generation/dev-invoice-generation.component';
import { WatchdogLogsComponent } from './pages/watchdog-logs/watchdog-logs.component';
import { BatchOutputInvoicesComponent } from './pages/batch-output-invoices/batch-output-invoices.component';
import { ViewInvoiceComponent } from './pages/view-invoice/view-invoice.component';
import { LoginComponent } from './pages/login/login.component';
import { TenantCreateComponent } from './pages/tenant-create/tenant-create.component';
import { ImportSummaryFilesListComponent } from './pages/import-summary-files-list/import-summary-files-list.component';
import { NewSureparkGroupFormComponent } from './components/new-surepark-group-form/new-surepark-group-form.component';

// Turn off during non-attendant portal projects
export function initializeAppFactory(
  messageService: MessageService,
  authService: AuthService,
  trpcService: TrpcService
): () => Observable<any> {

  console.log('initializeAppFactory triggered');

  return () => {
    // First, fetch the configuration to determine authentication mechanism
    return from(trpcService.trpc.healthcheck.getConfig.query()).pipe(
      switchMap((config) => {
        const authMechanism = config.authMechanism || 'DRUPALCOOKIE';
        console.log(`Using authentication mechanism: ${authMechanism}`);

        if (authMechanism === 'NG') {
          // Modern NG authentication approach with cookie caching
          console.log('NG Auth: Checking for stored cookie...');

          if (authService.hasStoredCookie()) {
            console.log('NG Auth: Found existing cookie, validating...');

            // Set the token in TrpcService first
            trpcService.setToken(authService.cookieData!);

            // Try to validate the existing cookie with getCurrentUser
            return from(trpcService.trpc.authRouter.getCurrentUser.query())
              .pipe(
                tap((user) => {
                  console.log('NG Auth: Existing cookie is valid. User:', user.username);
                  // Cookie is valid, keep using it
                }),
                catchError((error) => {
                  console.log('NG Auth: Existing cookie is invalid or expired, fetching new one...');
                  // Cookie is invalid, clear it and get a new one
                  authService.clearCookieFromStorage();

                  // Fall back to getCookie
                  return authService.getCookie()
                    .pipe(
                      catchError((getCookieError) => {
                        setTimeout(() => {
                          messageService.add({
                            severity: "error",
                            detail: "Unable to get current location, make sure you are logged into MPI portal.",
                          });
                        }, 0);
                        console.log(getCookieError);
                        return of();
                      }),
                      tap((output: CookieData) => {
                        if (output) {
                          console.log('NG Auth: New cookie obtained from getCookie');
                          authService.saveCookieToStorage(output);
                          trpcService.setToken(output);
                        }
                      })
                    );
                })
              );
          } else {
            console.log('NG Auth: No existing cookie found, calling getCookie...');

            // No existing cookie, get one from the portal
            return authService.getCookie()
              .pipe(
                catchError((error) => {
                  setTimeout(() => {
                    messageService.add({
                      severity: "error",
                      detail: "Unable to get current location, make sure you are logged into MPI portal.",
                    });
                  }, 0);
                  console.log(error);
                  return of();
                }),
                tap((output: CookieData) => {
                  if (output) {
                    console.log('NG Auth: Cookie obtained from getCookie');
                    authService.saveCookieToStorage(output);
                    trpcService.setToken(output);
                  }
                })
              );
          }
        } else if (authMechanism === 'DRUPALCOOKIE') {
          // Old DRUPALCOOKIE approach - always call getCookie directly
          console.log('DRUPALCOOKIE Auth: Using legacy authentication mechanism');
          console.log('DRUPALCOOKIE Auth: Calling getCookie directly (no cache check)...');

          return authService.getCookie()
            .pipe(
              catchError((error) => {
                setTimeout(() => {
                  messageService.add({
                    severity: "error",
                    detail: "Unable to get current location, make sure you are logged into MPI portal.",
                  });
                }, 0);
                console.log('DRUPALCOOKIE Auth: Error fetching cookie:', error);
                return of();
              }),
              tap((output: CookieData) => {
                if (output) {
                  console.log('DRUPALCOOKIE Auth: Cookie obtained from getCookie');
                  authService.saveCookieToStorage(output);
                  trpcService.setToken(output);
                }
              })
            );
        } else {
          console.error(`Unknown authentication mechanism: ${authMechanism}, defaulting to DRUPALCOOKIE`);
          // Default to DRUPALCOOKIE behavior if unknown mechanism
          console.log('Defaulting to DRUPALCOOKIE Auth: Calling getCookie...');
          return authService.getCookie()
            .pipe(
              catchError((error) => {
                setTimeout(() => {
                  messageService.add({
                    severity: "error",
                    detail: "Unable to get current location, make sure you are logged into MPI portal.",
                  });
                }, 0);
                console.log('Default Auth: Error fetching cookie:', error);
                return of();
              }),
              tap((output: CookieData) => {
                if (output) {
                  console.log('Default Auth: Cookie obtained from getCookie');
                  authService.saveCookieToStorage(output);
                  trpcService.setToken(output);
                }
              })
            );
        }
      }),
      catchError((configError) => {
        // If we can't fetch config, default to DRUPALCOOKIE behavior for backwards compatibility
        console.warn('Unable to fetch config, defaulting to DRUPALCOOKIE authentication', configError);

        // Fallback to DRUPALCOOKIE authentication when config fetch fails
        console.log('Config fetch failed: Using DRUPALCOOKIE fallback, calling getCookie...');

        return authService.getCookie()
          .pipe(
            catchError((error) => {
              setTimeout(() => {
                messageService.add({
                  severity: "error",
                  detail: "Unable to get current location, make sure you are logged into MPI portal.",
                });
              }, 0);
              console.log('Config fetch failed: Error fetching cookie:', error);
              return of();
            }),
            tap((output: CookieData) => {
              if (output) {
                console.log('Config fetch failed: Cookie obtained from getCookie (DRUPALCOOKIE fallback)');
                authService.saveCookieToStorage(output);
                trpcService.setToken(output);
              }
            })
          );
      })
    );
  };
}

@NgModule({
  declarations: [
    AppComponent,
    MonthlyInvoiceDetailsPageComponent,
    MonthlyInvoiceListComponent,
    InvoiceLineItemsComponent,
    InvoiceContactListComponent,
    InvoiceListComponent,
    TenantListComponent,
    ReportsComponent,
    TenantUpdatePageComponent,
    SettingsComponent,
    LeaseListComponent,
    LeaseViewComponent,
    DEVJABComponent,
    SUREPARKBillCouponsComponent,
    PerformaceMetricsComponent,
    SequenceManagementComponent,
    AccountsValidityUpdateComponent,
    TerminateContactsComponent,
    SureparkMergeComponent,
    DreReportComponent,
    ImportDailySummaryComponent,
    SUREPARKMemberIDsReportComponent,
    DashboardComponent,
    DailySummaryConfigurationComponent,
    CashierImportSheetSummaryComponent,
    UpdateRateComponent,
    LotSettingsComponent,
    WpsImportSheetSummaryComponent,
    SysparkImportSheetSummaryComponent,
    MonthlyBillingSummaryWidgetComponent,
    LocationSwitcherComponent,
    LocationDisplayComponent,
    TestLoginComponent,
    TestLogoutComponent,
    VersionComponent,
    DevInvoiceGenerationComponent,
    WatchdogLogsComponent,
    BatchOutputInvoicesComponent,
    ViewInvoiceComponent,
    LoginComponent,
    TenantCreateComponent,
    ImportSummaryFilesListComponent,
    NewSureparkGroupFormComponent
  ],
  imports: [
    // Code needed for serve or web components
    CommonModule,
    BrowserModule,
    ConfirmDialogModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ToolbarModule,
    InputTextModule,
    ButtonModule,
    DropdownModule,
    InputTextareaModule,
    InputSwitchModule,
    DialogModule,
    ProgressSpinnerModule,
    CalendarModule,
    ConfirmPopupModule,
    PanelModule,
    ToastModule,
    MessageModule,
    CheckboxModule,
    StepperModule,
    FileUploadModule,
    AutoCompleteModule,
    TooltipModule,
    MultiSelectModule,
    TagModule,
    ProgressBarModule,
    OrderListModule,
    BadgeModule,
    DividerModule,
    FieldsetModule,
    PanelMenuModule,
    TooltipModule,
    ContactsListComponent,
    OverlayPanelModule,
    RadioButtonModule,
    TabViewModule,
    ToggleButtonModule,
    PasswordModule,
    // Routing disabled for web component mode
    // AppRoutingModule,
  ],
  providers: [
    MessageService,
    NavigationService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [MessageService, AuthService, TrpcService],
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true }
  ],
  // No bootstrap for web component mode - use DoBootstrap
  // bootstrap: [AppComponent],
})

export class AppModule implements DoBootstrap {

  constructor(private injector: Injector) { }

  ngDoBootstrap() {
    //
    // Production web components
    //
    // const webComponentMonthlyInvoiceList = createCustomElement(MonthlyInvoiceListComponent, {injector: this.injector});
    // customElements.define('mpi-mothly-invoice-list', webComponentMonthlyInvoiceList);
    //
    // const webComponentMonthlyInvoiceDetails = createCustomElement(MonthlyInvoiceDetailsPageComponent, {injector: this.injector});
    // customElements.define('mpi-mothly-invoice-details', webComponentMonthlyInvoiceDetails);
    //
    // const webComponentInvoiceList = createCustomElement(InvoiceListComponent, {injector: this.injector});
    // customElements.define('mpi-invoice-list', webComponentInvoiceList);
    //
    // const webComponentReports = createCustomElement(ReportsComponent, {injector: this.injector});
    // customElements.define('mpi-reports', webComponentReports);
    //
    // const webComponentLeaseView = createCustomElement(LeaseViewComponent, {injector: this.injector});
    // customElements.define('mpi-lease-details', webComponentLeaseView);

    // The name of the customElements defined should be in the html file
    const webComponentSUREPARKCouponBilling = createCustomElement(SUREPARKBillCouponsComponent, { injector: this.injector });
    customElements.define('mpi-surepark-coupon-billing', webComponentSUREPARKCouponBilling);

    const webComponentSUREPARKLotSettings = createCustomElement(SettingsComponent, { injector: this.injector });
    customElements.define('mpi-surepark-lot-settings', webComponentSUREPARKLotSettings);

    const webComponentPerformanceMetrics = createCustomElement(PerformaceMetricsComponent, { injector: this.injector });
    customElements.define('mpi-performance-metrics', webComponentPerformanceMetrics);

    const webComponentAccountsValidityUpdate = createCustomElement(AccountsValidityUpdateComponent, { injector: this.injector });
    customElements.define('mpi-accounts-validity-update', webComponentAccountsValidityUpdate);

    const webComponentTerminateContactsComponent = createCustomElement(TerminateContactsComponent, { injector: this.injector });
    customElements.define('mpi-terminate-contacts', webComponentTerminateContactsComponent);

    const webComponentSureparkMergeComponent = createCustomElement(SureparkMergeComponent, { injector: this.injector });
    customElements.define('mpi-surepark-merge', webComponentSureparkMergeComponent);

    const webComponentImportSummaryFilesListComponent = createCustomElement(ImportSummaryFilesListComponent, { injector: this.injector });
    customElements.define('mpi-import-summary-files-list', webComponentImportSummaryFilesListComponent);

  }
}
